import { useQuery } from '@tanstack/react-query';
import api from '../../api/client';
import { queryKeys } from './queryKeys';

function withoutGeneralGroup(groups) {
  return (groups || []).filter((group) => String(group?.id || '').toLowerCase() !== 'general');
}

export async function fetchCatalog({ type, rubric }, signal) {
  try {
    const res = await api.get(
      `/content/catalog/${type}`,
      rubric ? { params: { rubric }, signal } : { signal },
    );
    return {
      items: Array.isArray(res?.data?.items) ? res.data.items : [],
    };
  } catch (error) {
    const canUseLegacyPhotoGroups =
      type === 'photo' &&
      (!rubric || rubric === 'all-photo') &&
      error?.response?.status === 404;

    if (!canUseLegacyPhotoGroups) throw error;

    const legacyRes = await api.get('/preset-groups', { signal });
    const groups = legacyRes?.data?.groups;
    return {
      items: Array.isArray(groups) ? withoutGeneralGroup(groups) : [],
    };
  }
}

export function useCatalogQuery(type, rubric, { enabled = true, refetchOnMount } = {}) {
  return useQuery({
    queryKey: queryKeys.catalog(type, rubric),
    queryFn: ({ signal }) => fetchCatalog({ type, rubric }, signal),
    enabled: enabled && Boolean(type),
    refetchOnMount,
  });
}
